import { render, staticRenderFns } from "./VivaViolinChart.vue?vue&type=template&id=c8d50a86"
import script from "./VivaViolinChart.vue?vue&type=script&lang=js"
export * from "./VivaViolinChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports